import React, { useState } from "react";
import { Container, Row, Col, Button, Form, Table } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import DashboardBuilder from "client_config/DashboardBuilder";
import { cloneDeep } from "lodash";
import CustomDropdown from "utils/CustomDropdown";

export default function Dashboard(props) {
  // Default dashboard to configure is the overall dashboard which will directly update the seo_section's dashboard_order. If there is valid id passed through parameters the controller will update the relevant landing page group.
  let initialDashboards = [{ name: "SEO: Overall", id: 0, dashboardOrder: props.seo_section.dashboard_order }];

  props.seo_section.landing_page_groups.forEach((el) => {
    initialDashboards.push({ name: el.name, id: el.id, dashboardOrder: el.dashboard_order });
  });
  if (props.onboarding && props.seoDashboard) {
    initialDashboards = props.seoDashboard;
  }
  const [dashboards, setDashboards] = useState(initialDashboards);
  const [selectedDashboard, setSelectedDashboard] = useState(dashboards[0].name);
  const [selectedDashboardId, setSelectedDashboardId] = useState(dashboards[0].id);
  const copyFromOverall = () => {
    console.log(dashboards, selectedDashboard);
    const index = dashboards.findIndex((el) => el.name == selectedDashboard);
    let newDashboards = dashboards;
    newDashboards[index].dashboardOrder = cloneDeep(dashboards[0].dashboardOrder);
    setDashboards([...newDashboards]);
  };
  return (
    <Container fluid className="seo-config-tab-content p-3 p-md-0 mb-5 py-4" style={{ backgroundColor: "#EEEEEE" }}>
      <div className="dash-pad">
        <div className="p-xl-4">
          <Row style={{ paddingLeft: "11px" }}>
            <Col>
              <h4 className="green">Dashboard modules:</h4>
            </Col>
          </Row>

          <Row className=" m-0 p-0 pl-3 pl-md-0 pt-2 ">
            <Col lg={10} md={12} xs={14} className="pl-0">
              <p className="d-inline-block f16 primary pr-4 mb-2">Select View:</p>
              <CustomDropdown platformName="SEO" dashboards={dashboards} selectedDashboardId={selectedDashboardId} setSelectedDashboardId={setSelectedDashboardId} selectedDashboard={selectedDashboard} setSelectedDashboard={setSelectedDashboard} />
              <div className="copy-btn d-md-inline-block d-block pl-md-3 pl-0">
                {dashboards.findIndex((el) => el.name == selectedDashboard) !== 0 && (
                  <Button style={{ paddingLeft: "10px", paddingRight: "10px", backgroundColor: "#3291c1" }} onClick={copyFromOverall}>
                    Copy dashboard setup from Overall
                  </Button>
                )}
              </div>
            </Col>
          </Row>
          <Row className="pl-2 pr-4 pt-4">
            <Col>
              <p className="f16">
                <strong>
                  Keep in mind you will need to configure the 'Landing Pages' tab above before they will appear in the 'Select View' dropdown above!&nbsp;
                </strong>
                Check the box to enable/disable, and click and drag the left handle to reorder your dashboard. Click 'Display configuration' to configure which
                metrics will show in each section.
              </p>
            </Col>
          </Row>
        </div>

        {dashboards
          .map((el) => {
            if (!el.name.includes("SEO: Overall")) {
              let newDash = el;
              let result = newDash.dashboardOrder.filter((dash) => {
                return dash.name !== "landingPageBreakdown";
              });
              el.dashboardOrder = result;
            }
            return el;
          })
          .map((dashboard, index) => {
            let visible = dashboard.name == selectedDashboard;
            return (
              <div style={{ display: visible ? "block" : "none" }} key={index}>
                <DashboardBuilder
                  service="seo"
                  dashboard={dashboard}
                  seoSection={props.seo_section}
                  enabledServices={props.enabled_services}
                  accountType={props.client_account.account_type}
                  onboarding={props.onboarding}
                  dashboards={dashboards}
                  setDashboard={props.setSeoDashboard}
                  currentDashboard={index}
                />
              </div>
            );
          })}
      </div>
    </Container>
  );
}
